import { IFieldContainer, IFieldDefinition } from 'app/interfaces';
import { fieldsMap } from './../fields';

const detailFormFields: (IFieldContainer|IFieldDefinition)[] = [
	{
		fields: [
			fieldsMap.get('access_username'),
			fieldsMap.get('name')
		]
	},
	{
		fields: [
			fieldsMap.get('email'),
			fieldsMap.get('role.name')
		]
	}
];

export default {
	fields: detailFormFields 
};
